import React from 'react';
import PropTypes from 'prop-types';
import { partition } from 'lodash';

import UserIconList from 'components/user_icon_list';

export default function DatabaseSwitch({
  availableDatabases,
  currentDatabaseId,
  currentDatabaseLabel,
  selectDatabaseLabel,
  onSelectDatabase
}) {
  const [companyDatabases, privateDatabases] = partition(availableDatabases, 'default');

  const databaseRow = (database) => {
    const selectButton = () => {
      if (database.id === currentDatabaseId) {
        return (
          <button className="btn btn-sm btn-cancel break-word disabled">
            {currentDatabaseLabel}
          </button>
        );
      } else {
        return (
          <button className="btn btn-sm btn-primary break-word" onClick={() => onSelectDatabase(database)}>
            {selectDatabaseLabel}
          </button>
        );
      }
    };

    return (
      <li className="list-group-item" key={database.id}>
        <div className="row row-eq-height">
          <div className="col-xs-6 col-sm-5">
            {database.name}
          </div>
          <div className="col-sm-3 hidden-xs text-right">
            <UserIconList placement="bottom" showHidden={false} size="24px" users={database.members}/>
          </div>
          <div className="col-xs-6 col-sm-4 text-right">
            {selectButton()}
          </div>
        </div>
      </li>
    );
  };

  const renderCompanyDatabases = () => {
    return (
      companyDatabases && companyDatabases.length > 0 &&
      <React.Fragment>
        <h3>Company</h3>
        <ul className="list-group">{companyDatabases.map(database => databaseRow(database))}</ul>          
      </React.Fragment>
    );
  };

  const renderPrivateDatabases = () => {
    return (
      privateDatabases && privateDatabases.length > 0 &&
      <React.Fragment>
        <h3>Private</h3>
        <ul className="list-group">{privateDatabases.map(database => databaseRow(database))}</ul>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {renderCompanyDatabases()}
      {renderPrivateDatabases()}
    </React.Fragment>
  );
}

DatabaseSwitch.propTypes = {
  availableDatabases: PropTypes.array.isRequired,
  currentDatabaseId: PropTypes.number.isRequired,
  currentDatabaseLabel: PropTypes.string.isRequired,
  selectDatabaseLabel: PropTypes.string.isRequired,
  onSelectDatabase: PropTypes.func.isRequired
};

DatabaseSwitch.defaultProps = {
  currentDatabaseLabel: 'Current Database'
};
